<template>
  <div class="d-flex justify-center">
    <v-menu offset-y>
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" icon>
          <v-icon color="primary">mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item>
          <v-list-item-title style="cursor: pointer" @click="goToMarkReview">
            Phúc khảo
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
export default {
  props: {
    selectedStudent: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    goToMarkReview() {
      this.$router.push('/student-mark-review')
    }
  }
}
</script>
